import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

import { ResultSocialMedia } from '../models/social-media.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocialMediaService {
  private readonly http = inject(HttpClient);

  getSocialMedia() {
    return this.http
      .get<ResultSocialMedia>(`${environment.apiUrl}social-media/`)
      .pipe(map((res) => res.results));
  }
}
